export default __webpack_public_path__ + "static/media/archicad-logo-brandlogos.net_zwenzuxuc.d319f55c.svg";